import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { FilterService } from "@progress/kendo-angular-grid";
import { BaseFilterClass } from "./BaseFilterClass";

export class MSFilterClass extends BaseFilterClass {
    constructor(fieldName: string) {
        super(fieldName);
    }
    public genericFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        this.genericFilter.splice(
            0, this.genericFilter.length,
            ...BaseFilterClass.flatten(filter).map(({ value }) => value)
        );
        return this.genericFilter;
    }
    public genericFilterChange(values: any[], filterService: FilterService): void {
        filterService.filter({
            filters: values.map(value => ({
                field: this.fieldName,
                operator: 'eq',
                value
            })),
            logic: 'or'
        });
    }

}